import React, {Component} from "react";
import axios from "axios";
import {ItemTypes} from "../BuildCube/Constant";
import {DropTarget} from "react-dnd";
import joint from "jointjs";
import $ from "jquery";
import Element from "../BuildCube/JointProjectModule"

const elementTarget = {
  drop: (props, monitor, component) => {
    console.debug("ProjectPlayground elementTarget:",
      monitor.getItem().elId,
      monitor.getItem().name,
      monitor.getItem().type,
      monitor.getItem().relativeOffset,
      monitor.getInitialClientOffset(),
      monitor.getInitialSourceClientOffset(),
      monitor.getClientOffset(),
      monitor.getDifferenceFromInitialOffset(),
      monitor.getSourceClientOffset(),
      monitor.getDropResult()
    );
    console.debug("ProjectPlayground clientOffset:", component.props.getClientOffset(), component);
    component.props.updateClientOffset(component.props.getClientOffset());
    component.renderProjectModule(
      monitor.getItem().elId,
      monitor.getItem().name,
      monitor.getItem().type,
      monitor.getItem().logo,
      monitor.getItem().relativeOffset,
      monitor.getClientOffset()
    );
  },
  hover: (props, monitor, component) => {
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  }
}

class ProjectPlayground extends Component {

  constructor() {
    super();
    this.renderProjectModule = this.renderProjectModule.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.fetchDataHelper = this.fetchDataHelper.bind(this);
    this.drawModule = this.drawModule.bind(this);
  }

  render() {
    const {connectDropTarget, isOver} = this.props;
    return connectDropTarget(
      <div style={{
        border: `1px solid ${isOver ? "rgba(202,10,10,1)" : "rgba(0,0,0,.1)"}`
      }}
        ref={view => this.view = view}
        id="diagram"
      >
      </div>
    )
  }

  renderProjectModule(elId, name, type, logo, relativeOffset, offset) {

    const calculatedX = offset.x-this.props.selfOffset.x-relativeOffset.x;
    const calculatedY = offset.y-this.props.selfOffset.y-relativeOffset.y;
    console.debug("ProjectPlaygroun position:", calculatedX, calculatedY);

    type = type.toLowerCase();
    let module = this.drawModule(elId, name, type, logo, calculatedX, calculatedY);
    let previousResponse = null;

    this.fetchData(elId, type)
      .then(
        response => {
          console.debug("ProjectPlayground fetchData:", response);
          switch(type) {
            case "dataset":
              response.nodeId = module.id;
              this.props.updateDataSetMap(response);
              break;
            case "model":
              response.nodeId = module.id;
              this.props.updateModelMap(response);
              break;
            case "algorithm":
              previousResponse = response;
              return this.fetchDataHelper(`/api-algorithm/algorithms/${elId}?projection=exposeAllAlgorithmFields`);
            default:
              console.error("ProjectPlayground: invalid type");
          }
        }
      ).then(
        response => {
          if (type === "algorithm") {
            const inputParams = previousResponse._embedded.algorithmParameters.filter(param => param.type === "MODEL_IN" || param.type === "DATASET_IN");
            const outputParams = previousResponse._embedded.algorithmParameters.filter(param => param.type === "MODEL_OUT" || param.type === "DATASET_OUT");
            const noramInputParams = previousResponse._embedded.algorithmParameters.filter(param => param.type !== "MODEL_IN" && param.type !== "DATASET_IN" && param.type !== "MODEL_OUT" && param.type !== "DATASET_OUT");
            this.props.updateAlgorithmMap({
              nodeId: module.id,
              algorithmId: elId,
              inputParams: inputParams,
              outputParams: outputParams,
              normalInputParams: noramInputParams
            });
            response.nodeId = module.id;
            this.props.updateAlgorithmBasic(response);
            console.debug("ProjectPlayground algorithm module:", module.attributes);
            inputParams.forEach((inputParam, index) => {
              let type = inputParam.type.split("_")[0];
              let labelStr = null;
              console.log("in labelStr:", inputParam.type.split("_")[0]);
              if (type === "MODEL")
                labelStr = "输入模型";
              if (type === "DATASET")
                labelStr = "输入数据";
              module.addInPort(`${labelStr}${index}`);
              // module.ddPort({s
              //   group: "in",
              //   attrs: {text: {text: `${labelStr}${index}`}}
              // })
            });
            outputParams.forEach((outputParam, index) => {
              let type = outputParam.type.split("_")[0];
              let labelStr = null;
              console.log("out labelStr:", outputParam.type.split("_")[0]);
              if (type === "MODEL")
                labelStr = "输出模型";
              if (type === "DATASET")
                labelStr = "输出数据";
              module.addOutPort(`${labelStr}${index}`);
              // module.addPort({
              //   group: "out",
              //   attrs: {text: {text: `${labelStr}${index}`}}
              // })
            });
            console.log("ProjectPlayground algorithm module:", module);
          }
          this.props.addCell(module);
        }
      ).catch(
        ex => console.error("ERROR: failed to get module details", ex)
      )
  }

  fetchData(id, type) {
    switch(type) {
      case "dataset":
        return this.fetchDataHelper(`/api-bigdata/datasets/${id}`);
      case "algorithm":
        return this.fetchDataHelper(`/api-algorithm/algorithmParameters/search/algorithmParameterInfo?algorithmId=${id}`);
      case "model":
        return this.fetchDataHelper(`/api-bigdata/models/${id}`);
      default:
        console.error("fetchData error invalid type:", type);
        return null;
    }
  }

  fetchDataHelper(url) {
    return axios({
      url: url,
      method: "GET"
    }).then(
      response => {
        return response.data
      }
    ).catch(
      ex => {
        console.error("fetchDataHelper exception:", ex);
        return null;
      }
    )
  }

  drawModule(elId, name, type, logo, calculatedX, calculatedY) {
    let module = null;
    switch(type) {
      case "dataset":
        module = new joint.shapes.html.Element({
          position: { x: calculatedX, y: calculatedY},
          size: { width: 200, height: 40 },
          icon: `/api-imagefiles/browse?name=${logo}`,
          label: name,
          status: "",
          inPorts: [],
          outPorts: ["输出数据0"], // 输出0
          elId: elId,
          elType: type
        });
        break;
      case "algorithm":
        module = new joint.shapes.html.Element({
          position: { x: calculatedX, y: calculatedY },
          size: { width: 200, height: 40 },
          icon: `/api-imagefiles/browse?name=${logo}`,
          label: name,
          status: "status-info running anticon anticon-info-circle",
          inPorts: [],
          outPorts: [],
          elId: elId,
          elType: type
        });
        break;
      case "model":
        module = new joint.shapes.html.Element({
          position: { x: calculatedX, y: calculatedY },
          size: { width: 200, height: 40 },
          icon: `/api-imagefiles/browse?name=${logo}`,
          label: name,
          status: "",
          inPorts: [],
          outPorts: ["输出模型0"], // 数据0
          elId: elId,
          elType: type
        });
        break;
      default:
        module = null;
    }
    return module;
  }
}

export default DropTarget(ItemTypes.ELEMENT, elementTarget, collect)(ProjectPlayground);
